// eslint-disable-next-line max-len
var USER_INTERFACE_PASSWORD_EYE_SHOW = 'M32,16S24.84,6,16,6,0,16,0,16H0S7.16,26,16,26,32,16,32,16ZM16,23.09a7,7,0,1,1,7-7A7.05,7.05,0,0,1,16,23.09ZM2.38,16A28.13,28.13,0,0,1,10,9.43a8.92,8.92,0,0,0-.2,13.05A28.87,28.87,0,0,1,2.38,16Zm19.9,6.43A8.92,8.92,0,0,0,22,9.37,28.65,28.65,0,0,1,29.62,16,28.45,28.45,0,0,1,22.28,22.42Z';

export { USER_INTERFACE_PASSWORD_EYE_SHOW };
//# sourceMappingURL=USER_INTERFACE_PASSWORD_EYE_SHOW.js.map
